import React from 'react'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import ButtonTC from '../../components/button-tc/button-tc'
import styled from 'styled-components'
import SectionTC from '../../components/section-tc/section-tc'
import { FaceSmile } from '@styled-icons/fa-regular'
import { TicketPerforated } from '@styled-icons/bootstrap'
import { User } from '@styled-icons/boxicons-regular'
import { ArrowBackOutline } from '@styled-icons/evaicons-outline'
import { device } from '../../config/theme/breakpoints'
import { ArrowRight } from '@styled-icons/bootstrap'
import { NavLink } from 'react-router-dom'

const FeatureCustomClass = `
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 300px;
    gap: 10px;

    > h2{
        color: white;
        width: fit-content;
        margin: 0;
    }

    > svg {
        max-width: 35px;
        color: white;
    }
`


const ContainerItinerario = styled.div`
  width: 100%;
  margin: auto;
  border-radius: 20px;
  box-shadow: 0px 2px 12px 0px #d9d9d9;
`
const ContainerHeader = styled.div`
  background:  ${p => p.theme.palette.primary.main};
  text-align: center;
  border-radius: 20px 20px 0 0;
  padding: 4px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
  height: 55px;
  
  > h4 {
    color: white;
    margin: 0;
  }
`
const TableWrapper = styled.div`
  width: fit-content;
  margin: auto;
  padding: 30px 10px;
`
const HeadTableWrapper = styled.div`
  border-bottom: 1px solid ${p => p.theme.palette.grayLight};
  padding-bottom: 10px;

  > th {
    color:  ${p => p.theme.palette.primary.main};
    margin-left: 10px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    padding: 5px 10px;
    min-width: 130px;
  }
`
const BodyTableWrapper = styled.div`
  padding-top: 10px;

  > tr td {
    color:  ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
    text-align: center;
    padding: 15px 10px;
    width: 1%;
  }
`

const ContainerInfoTop = styled.div`
  text-align: center;
  margin: 20px 0;

  > h2 {
    color:  ${p => p.theme.palette.text.grayLight};
    margin: 0;
  }

  > h4 {
    color:  ${p => p.theme.palette.primary.main};
    margin: 0;
    margin-bottom: 5px;
  }
`

const ContainerInfoDown = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  > div p {
    color:  ${p => p.theme.palette.text.grayLight};

    > b {
        color:  ${p => p.theme.palette.text.gray};
    }
  }

  > div:nth-child(1){
    text-align: left;
  }
  > div:nth-child(2){
    text-align: right;
  }
`

const ContainerInfo = styled.div``
const ContainerBoletos = styled.div``
const ContainerOptions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 40px;

    > div, a {
        display: flex;
        flex-direction: row;
        min-width: 150px;
        color: ${p => p.theme.palette.text.gray};
        text-decoration: none;

        > p {
            cursor: pointer;
        }
        > svg {
            max-width: 20px;
            cursor: pointer;
        }
    }

    @media ${device.tablet}{
      flex-direction: row;
    }
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${p => p.theme.palette.text.grayLight};
  border-radius: 50px;
`
const ContainerTextTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;

  > h3 {
    color:  ${p => p.theme.palette.primary.main};
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;

    @media ${device.tablet}{
      width: 48%;
      justify-content: flex-end;
    }
  }

  > h3 svg {
    width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  > p{
    color:  ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
    margin: 0;
    width: 100%;
    text-align: center;

    @media ${device.tablet}{
      width: 48%;
      text-align: left;
    }
  }
`
const ContainerWrapperTable = styled.div`
  overflow: auto;
`

const PaymentFinish: React.FunctionComponent = () => {
  return (
    <Layout>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            <h2>¡ Felicidades !</h2>
            <FaceSmile />
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
            <ContainerInfoTop>
                <h4>Se realizó con éxito su compra</h4>
                <h2>MIGUEL ANGEL ZICIA OSORIO</h2>
            </ContainerInfoTop>
            <Divider />
            <ContainerInfoDown>
                <div>
                    <p><b>Nº de Pedido: </b>00000515112312</p>
                    <p><b>Total: </b>S/ 400.00</p>
                </div>
                <div>
                    <p><b>Fecha de Transacción: </b>13/07/2022</p>
                    <p><b>Hora de Transacción: </b>06:14 PM</p>
                </div>
            </ContainerInfoDown>
        </SectionTC>
        <SectionTC>
            <ContainerItinerario>
                <ContainerHeader><h4>Detalle de la compra</h4></ContainerHeader>
                <ContainerTextTop>
                  <h3>
                    Lima
                    <ArrowRight />
                    Chiclayo
                  </h3>
                  <p>Miercoles 10 de Agosto</p>
                </ContainerTextTop>
                <ContainerWrapperTable>
                  <TableWrapper>
                    <HeadTableWrapper>
                      <th>Pasajero</th>
                      <th>Comprobante</th>
                      <th>Asiento</th>
                      <th>Precio</th>
                      <th>Embarque</th>
                      <th>Dirección</th>
                      <th>Hora de embarque</th>
                    </HeadTableWrapper>
                    <BodyTableWrapper>
                      <tr>
                        <td>Pasajero 1</td>
                        <td>B995-018703</td>
                        <td>06</td>
                        <td>S/ 100.00</td>
                        <td>Chiclayo</td>
                        <td>Av. Jose Leonardo Ortis Nº 010</td>
                        <td>06:30 PM</td>
                      </tr>
                      <tr>
                        <td>Pasajero 2</td>
                        <td>B995-018703</td>
                        <td>06</td>
                        <td>S/ 100.00</td>
                        <td>Chiclayo</td>
                        <td>Av. Jose Leonardo Ortis Nº 010</td>
                        <td>06:30 PM</td>
                      </tr>
                      <tr>
                        <td>Pasajero 3</td>
                        <td>B995-018703</td>
                        <td>06</td>
                        <td>S/ 100.00</td>
                        <td>Chiclayo</td>
                        <td>Av. Jose Leonardo Ortis Nº 010</td>
                        <td>06:30 PM</td>
                      </tr>
                    </BodyTableWrapper>
                  </TableWrapper>
                </ContainerWrapperTable>
            </ContainerItinerario>
        </SectionTC>
        <SectionTC>
            <ContainerInfo></ContainerInfo>
            <ContainerBoletos></ContainerBoletos>
            <ContainerOptions>
                <NavLink to='/'>
                  <ArrowBackOutline/>
                  <p>Volver al inicio</p>
                </NavLink>
                <div>
                    <ButtonTC text='Ver ticket' icon={<TicketPerforated />} />
                </div>
                <div>
                    <ButtonTC text='Ir a mi cuenta' icon={<User />} buttonStyle='secondary' to='/mi-cuenta'/>
                </div>
            </ContainerOptions>
        </SectionTC>
        
    </Layout>
  )
}

export default PaymentFinish